import { CoreBox, CoreText, CoreChip, type IconName, type ChipColorToken } from '@vitvio/design-system';
import type { ORStatusType } from './types';

const statusConfigs: Record<ORStatusType, { translationKey: string; icon: IconName; color: ChipColorToken }> = {
  delays: {
    translationKey: 'platform:missionControl.orStatus.delays',
    icon: 'warning',
    color: 'warning',
  },
  ahead: {
    translationKey: 'platform:missionControl.orStatus.ahead',
    icon: 'schedule',
    color: 'Ahead/AI',
  },
  idle: {
    translationKey: 'platform:missionControl.orStatus.idle',
    icon: 'timer',
    color: 'default',
  },
  unavailable: {
    translationKey: 'platform:missionControl.orStatus.unavailable',
    icon: 'signal_wifi_off',
    color: 'default',
  },
  notDeployed: {
    translationKey: 'platform:missionControl.orStatus.notDeployed',
    icon: 'lock',
    color: 'default',
  },
  onTime: {
    translationKey: 'platform:missionControl.orStatus.onTime',
    icon: 'check_circle',
    color: 'primary',
  },
};

interface Props {
  name: string;
  status: ORStatusType;
}

export function ORColumnHeader({ name, status }: Props) {
  const statusConfig = statusConfigs[status];

  return (
    <CoreBox flexRow alignItems="center" gap="5" px="2" flexGrow={1}>
      <CoreText font="metric.L_Medium" color="fg">
        {name}
      </CoreText>
      <CoreChip
        path={statusConfig.translationKey}
        iconLeft={statusConfig.icon}
        variant="flat"
        size="md"
        color={statusConfig.color}
      />
    </CoreBox>
  );
}
